/* VR 2026-10-02 — desktop product gallery.
   Big stage image, the rest as a grid underneath; a click puts a tile on the
   stage. Also keeps the product info column in view: it scrolls along and then
   stops at its last position instead of disappearing, which needs a computed
   sticky offset because the column is taller than the window. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function initGallery() {
    var root = document.querySelector('[data-vr-gallery]');
    if (!root) return;
    var stage = root.querySelector('.vr-media-stack__stage-img');
    var tiles = root.querySelectorAll('[data-vr-tile]');
    if (!stage || !tiles.length) return;

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var full = tile.getAttribute('data-full');
        if (!full) return;
        stage.removeAttribute('srcset');
        stage.src = full;
        stage.alt = tile.getAttribute('data-alt') || stage.alt;
        tiles.forEach(function (t) { t.classList.remove('is-active'); });
        tile.classList.add('is-active');
      });
    });
  }

  /* Which column gets pinned depends on the product: a short image column
     (few photos, long configurator) should ride along, while a long image
     column must scroll and the info column holds its last position instead.
     Pinning a column taller than the window would hide its lower half. */
  function initStickyColumns() {
    var info = document.querySelector('.product__info-wrapper');
    var media = document.querySelector('.product__media-wrapper');
    if (!info || !media) return;

    function apply() {
      info.classList.remove('vr-pinned');
      media.classList.remove('vr-pinned');
      info.style.removeProperty('--vr-info-top');
      media.style.removeProperty('--vr-info-top');
      if (!DESKTOP.matches) return;

      var headroom = 120; // header + a little air
      var gap = 24;
      /* Pin the shorter column — that one can stay in view while the longer one
         scrolls past. A column taller than the window scrolls up first and then
         holds its last position, otherwise its lower half would never show. */
      /* Height alone is unreliable: tiles load lazily, so a 25-image column
         measures short at first. The tile count says what it will become. */
      var tiles = media.querySelectorAll('.vr-media-stack__item').length;
      var mediaIsLong = tiles > 4 || media.offsetHeight > info.offsetHeight;
      var shorter = mediaIsLong ? info : media;
      if (!mediaIsLong && Math.abs(media.offsetHeight - info.offsetHeight) < 40) return;
      shorter.classList.add('vr-pinned');
      shorter.style.setProperty('--vr-info-top',
        Math.round(Math.min(headroom, window.innerHeight - shorter.offsetHeight - gap)) + 'px');
    }

    apply();
    window.addEventListener('resize', apply);
    if (window.ResizeObserver) {
      /* Through rAF: apply() changes layout, and measuring straight inside the
         observer callback makes the browser log "ResizeObserver loop …". */
      var queued = false;
      var ro = new ResizeObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; apply(); });
      });
      ro.observe(info);
      ro.observe(media);
    }
    // Globo renders its fields late and changes the column height.
    setTimeout(apply, 1500);
    setTimeout(apply, 4000);
  }

  function init() { initGallery(); initStickyColumns(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
